<template>
  <li @click.stop.prevent='moveToMenuDetail'>
    <a class='row'>
      <div class='col col1'>
        <div class='name'>
          <MenuName :menu='menu' :mainFlag='0'>
            <span class='menuName'>{{menu.name}}</span>
          </MenuName>
        </div>
        <div class="menuDesc">
          {{menu.desc}}
        </div>
        <div :class='disableOrderMenu?"price disabled":"price"'>
          <span class='num'>
            <em>{{formatComma(menu.price)}}</em><em class='won'>{{$t('MoneyUnit')}}</em>
          </span>
          <span v-if='disableOrderMenu' class='tag'>{{$t(tag)}}</span>
        </div>
        <div v-if="menu.phoneFlag == 1">
          전화문의
        </div>
      </div>
      <div v-if='checkStringData(menuImage)' class='col col2'>
        <img class='thum' :src='menuImage'/>
      </div>
    </a>
    <a
      v-if='ableDelMenu'
      class='btn_del'
      @click.stop.prevent='$emit("onClickDelBtn", menu.code, index)'>삭제<i class='icoDel'></i></a>
  </li>
</template>
<script lang="js">
import { MENU_ITEM } from '@/utils/EndPoint'
import { THROW_MENU } from '@/router/index'
import MenuName from '@/components/Common/MenuName.vue'
import Vue from 'vue'
import { SET_CURRENT_MENU } from '@/store/_actions/actionTypes'
export default Vue.extend({
  name: MENU_ITEM,
  props: [
    'menu', // 상품 정보
    'index', // 상품의 index 번호
    'ableDelMenu', // 삭제 버튼 show flag
    'disableMenuDetail' // 상품 상세 이동 불가 flag
  ],
  components: { MenuName },
  data () {
    return {
      fullVUi: this.$store.getters.fullVUi,
      menuImage: this.menu.imagePath, // 상품 이미지 썸네일
      disableOrderMenu: false,
      tag: '',
      alive: this.$store.getters.alive // pos on/off
    }
  },
  created () { this.setOrderFlag() },
  updated () { this.setOrderFlag() },
  computed: {
    ableOrderFlag () { return this.$store.getters.ableOrderFlag }
  },
  methods: {
    setOrderFlag () {
      this.disableOrderMenu = // 주문불가능한 상품
        this.menu.soldOutTodayFlag ||
        this.menu.outOfTimeFlag ||
        this.menu.deleteMenuFlag
      this.tag = this.menu.deleteMenuFlag ? 'soldOut2'
        : this.menu.soldOutTodayFlag ? 'soldOut' : 'soldOut3'
    },
    moveToMenuDetail () { // 상품 상세 페이지로 이동
      if (!this.disableMenuDetail) {
        if (this.fullVUi) THROW_MENU(this.menu.code)
        else if (!this.disableOrderMenu && this.ableOrderFlag && this.alive) {
          this.$store.dispatch(SET_CURRENT_MENU, this.menu)
            .then(() => this.createPopUp('#simple.cusLayer'))
        }
      }
    }
  }
})
</script>
